import { afterNextRender, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, signal, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'bokun-portal',
  templateUrl: './redemption-portal.component.html',
  styleUrls: ['./redemption-portal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedemptionPortalBokunComponent {
  document = inject(DOCUMENT);
  router = inject(Router);
  activated = inject(ActivatedRoute);
  collabImage = signal<string|null>(null);

  constructor() {
    const queryParams = this.activated.snapshot.queryParams;
    
    if(!queryParams.channel_id || !queryParams.bokun_id){
      this.router.navigate(['/']);
      return;
    }

    if(queryParams.channel_id == '0f3a7474-433f-41d5-9e1a-a40b4209a780'){
      //if arrigo
      this.collabImage.set('old/tourist/robert-arrigo.png');
    }

    afterNextRender(() => {
      const script = this.document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = `https://widgets.bokun.io/assets/javascripts/apps/build/BokunWidgetsLoader.js?bookingChannelUUID=${queryParams.channel_id}`;

      const div = this.document.createElement('div');
      div.className = 'bokunWidget';
      div.setAttribute('data-src', `https://widgets.bokun.io/online-sales/${queryParams.channel_id}/experience/${queryParams.bokun_id}`);

      const noscript = this.document.createElement('noscript');
      noscript.innerText = 'Please enable javascript in your browser to book';

      const bokunWindow = this.document.getElementById('portal-window');

      bokunWindow?.append(script, div, noscript);
    });

   }

}

@Component({
  selector: 'excursion-portal',
  templateUrl: './redemption-portal.component.html',
  styleUrls: ['./redemption-portal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.fixed]': 'true'
  }
})
export class RedemptionPortalMaltaExcursionsComponent {
  document = inject(DOCUMENT);
  router = inject(Router);
  activated = inject(ActivatedRoute);
  collabImage = signal<string|null>('old/tourist/maltaexcursion.jpg');
  
  constructor() {
    const queryParams = this.activated.snapshot.queryParams;
    
    if(!queryParams.item){
      this.router.navigate(['/']);
      return;
    }

    afterNextRender(() => {
      const iframe = this.document.createElement('iframe');
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = 'none';
      
      iframe.src = `https://app.maltaexcursion.com/${queryParams.item.replace(/^\//, '')}${queryParams.item.endsWith('.html') ? '' : '.html'}`;
   
      const excursionWindow = this.document.getElementById('portal-window');
   
      excursionWindow?.append(iframe);
    });
   }
}
